// import IframeLoader from "_platform/output/iframeloader.vue";
// import DsfStatsAuditFormulaForm from '../audit/formulaForm.vue';

let router = [
  {
    path: "/iframeloader/:state?",
    name: "iframeloader",
    component: () => import(/* webpackChunkName: "router_iframe" */ "_platform/output/iframeloader.vue"),
    meta: {
      title: ""
    },
    props: (route) => {
      // let src = decodeURIComponent(route.fullPath)
      return {
        src: route.query.src
      };
    }
  },
  {
    path: "/pc/audit/formula/form",
    meta: {
      title: "审核公式维护",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "router_audit_editor" */ "../audit/formulaForm.vue")
  },
  {
    path: "/pc/aiCenterHome",
    meta: {
      title: "智能中心",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "router_smart_center_home" */ "../views/smartCenterHome/index.vue")
  },
  {
    path: "/pc/form/history",
    meta: {
      title: "表单修改历史",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "router_form_history" */ "../views/formHistory")
  },
  {
    path: "/pc/error401",
    meta: {
      title: "会话已过期",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "router_error" */ "../views/Error401")
  }
];

export default router;
